export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑需求',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    disabled: ({ approvalStatus }) => {
      return that.disabled || !['N', 'B'].includes(approvalStatus)
    },
  },
  {
    text: that.$l('INDEX.btn_rep_cancel') || '不补货',
    icon: 'el-icon-delete',
    menuType: 'delete',
    disabled: ({ approvalStatus }) => {
      return that.disabled || !['N', 'B'].includes(approvalStatus)
    },
  },
  {
    text: that.$l('btn_stopReplenishment') || '该产品不再补货',
    icon: 'el-icon-close',
    menuType: 'stop',
    disabled: ({ approvalStatus }) => {
      return that.disabled || !['N', 'B'].includes(approvalStatus)
    },
  },
]
